const LEGAL_FORMS = [
	"spol\\.\\s?s\\s?r\\.\\s?o\\.?",
	"s\\.\\s?r\\.\\s?o\\.?",
	"a\\.\\s?s\\.?",
	"v\\.\\s?o\\.\\s?s\\.?",
	"o\\.\\s?p\\.\\s?s\\.?",
	"k\\.\\s?s\\.?",
	"z\\.\\s?s\\.?",
	"z\\.\\s?ú\\.?",
	"s\\.\\s?p\\.?",
	"státní podnik",
	"družstvo",
];

const SUFFIX = new RegExp(
	`(?:^|[\\s,])[\\s,]*(?:${LEGAL_FORMS.join("|")})(\\s*\\([^)]*\\))?\\s*$`,
	"i",
);

export const getHspDisplayName = (name: string): string =>
	name
		.replace(SUFFIX, (_match, parens: string | undefined) => parens ?? "")
		.trim();
